import linkedinlearn from "../assets/linkedin learn.jpeg"
import meta from "../assets/Meta.jpeg"
import openclassrooms from "../assets/openclassrooms.jpeg"
const certificationsdata = [
    {
        id: 1,
        title: "Advanced React",
        company: "Coursera & Meta",
        date: "Aug 2023",
        credential: "https://coursera.org/share/2bd8ed8a317851df2d9fb0b01b39b42d",
        image: meta,
    },
    {
        id: 2,
        title: "React basics",
        company: "Coursera & Meta",
        date: "Jul 2023",
        credential: "https://coursera.org/share/7fe93547a363e371cd0fb459b11ebdd6",
        image: meta,   
    },
    {
        id: 3,
        title: "Web App->React.js",
        company: "OpenClassrooms",
        date: "Jun 2023",
        credential: "https://students.yourlearning.ibm.com/certificate/share/74ea3cb4c1ewogICJsZWFybmVyQ05VTSIgOiAiMTQ2NTU3NVJFRyIsCiAgIm9iamVjdElkIiA6ICJVUkwtRDNGNTU5OUJBODhCIiwKICAib2JqZWN0VHlwZSIgOiAiQUNUSVZJVFkiCn071f5f4190a-10",
        image: openclassrooms,
    },
    {
        id: 4,
        title: "Docker",
        company: "LinkedIn Learn",
        date: "May 2023",
        credential: "https://drive.google.com/file/d/1oD_0A11JnTR8M-IzPWirUAI2lDUurGdl/view?usp=sharing",
        image: linkedinlearn,
    },
    {
        id: 5,
        title: "Postman",
        company: "LinkedIn Learn",
        date: "May 2023",
        credential: "https://drive.google.com/file/d/1x92DnC7btanru8HA9FHSPaMylaFEBsUP/view?usp=sharing",
        image: linkedinlearn,
    },
    {
        id: 6,
        title: "Data Structures",
        company: "LinkedIn Learn",
        date: "Nov 2022",
        credential: "https://drive.google.com/file/d/1YZ6odd2_PeVOAjHuSohnczI2lKaymHCy/view?usp=sharing",
        image: linkedinlearn,
    },
    {
        id: 7,
        title: "P F: Databases",
        company: "LinkedIn Learn",
        date: "Nov 2022",
        credential: "https://drive.google.com/file/d/1XIyrbKGMX_dYmjvaAainSEEx-5dkxcD-/view?usp=sharing",
        image: linkedinlearn,
    },
    {
        id: 8,
        title: "Learning Java",
        company: "LinkedIn Learn",
        date: "Dec 2021",
        credential: "https://drive.google.com/file/d/1mNit-Ch7UvO7ZrxX__OJP1_SOwChmuEC/view?usp=sharing",
        image: linkedinlearn,
    },
    {
        id: 9,
        title: "P F: Algorithms",
        company: "LinkedIn Learn",
        date: "Jul 2023",
        credential: "https://drive.google.com/file/d/1lgX8q6LV2XICb2P7mzBpvVORfUkEdalQ/view?usp=sharing",
        image: linkedinlearn,
    },
    
]

export default certificationsdata;